/* eslint-disable max-len */
import React from 'react';
import { CalendarWithTimeWheelIconTrigger } from './CalendarWithTimeWheelIconTrigger.js';
import { CalendarWithTimeWheelWrapper } from './CalendarWithTimeWheelWrapper.js';
import { CalendarWithTimeWheelContext } from './CalendarWithTimeWheelContext.js';
import { useConfigCalendarWithTimeWheelCTX } from './useConfigCalendarWithTimeWheelCTX.js';
import { WrappedCalendarContext } from '../Calendar/Calendar.js';
import { WrappedTimeWheelContext } from '../TimeWheel/TimeWheel.js';

const CalendarWithTimeWheelContent = () => {
  const ctx = useConfigCalendarWithTimeWheelCTX();
  const { showCalendarWithTimeWheel, isControllerOnly, handleMenuWrapperKeyDown } = ctx;

  return (
    <CalendarWithTimeWheelContext.Provider value={ctx}>
      {isControllerOnly ? null : <CalendarWithTimeWheelIconTrigger />}
      {isControllerOnly || showCalendarWithTimeWheel ? (
        <>
          {/* The <div> element is catching the "ESC" key to close the calendar, there is no valid aria role for this */}
          {/* https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events */}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onKeyDown={handleMenuWrapperKeyDown}>
            <CalendarWithTimeWheelWrapper />
          </div>
        </>
      ) : null}
    </CalendarWithTimeWheelContext.Provider>
  );
};

// we wrap in context in a separate statement so we can use the useContext and be sure it's correctly initialized
export const CalendarWithTimeWheel = () => (
  <WrappedCalendarContext>
    <WrappedTimeWheelContext>
      <CalendarWithTimeWheelContent />
    </WrappedTimeWheelContext>
  </WrappedCalendarContext>
);
